<template lang="pug">
el-collapse#card-dados-territorio(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}
                span.erro(v-if='$v.dados.$invalid') *

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit("removerTerritorio", territorio.id)'
                )

        el-form.form.p-2(label-position='top', size='small')
            .box
                .box-esquerda
                    .dados
                        el-form-item.tamanho-area-texto
                            .label(slot='label')
                                span {{ $t('mensagens.laudos.descricoes') }}
                                span.erro(v-if='$v.descricao.$invalid') *
                            el-input.area-fixa(
                                type='textarea',
                                :rows='8',
                                v-model.lazy='descricao',
                                maxlength='299'
                            )

                .box-direita
                    el-form-item
                        span.arquivos.complementares {{ $t('mensagens.laudos.arquivosComplementares') }}
                        el-upload.upload-demo(
                            action='#',
                            :auto-upload='false',
                            :on-change='onLoadFile',
                            :on-remove='onRemoveFile',
                            :before-upload='antesUploadArquivo',
                            :on-exceed='verificarLimite',
                            :before-remove='antesRemoverArquivo',
                            multiple,
                            :limit='3',
                            drag,
                            :file-list='fileList'
                        )
                            i.el-icon-upload(style='margin-top: 40px')
                            .el-upload__text {{ $t('mensagens.laudos.arrasteParaSubir.1') }} <em>{{ $t('mensagens.laudos.arrasteParaSubir.2') }}</em><br> {{ $t('mensagens.laudos.arrasteParaSubir.3') }}
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import TipoLaudo from '@/constants/TipoLaudo';
import UploadHelp from '@/constants/UploadHelp';
import LaudosService from '@/services/LaudosService';
import axios from 'axios';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'CardDadosTerritorioAvaliacaoFundiaria',
    components: {
        BaseButton
    },
    emits: ['removerTerritorio', 'getDados', 'getValidacao'],

    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            collapse: ['item'],
            descricao: '',
            arquivosUploads: [],
            fileList: []
        };
    },

    mounted() {
        this.$emit('getValidacao', {
            valido: !this.$v.dados.$invalid,
            id: this.territorio.id
        });
    },

    watch: {
        '$v.dados.$invalid': function () {
            this.emitDados();
        },

        descricao: function () {
            this.emitDados();
        }
    },

    validations: {
        descricao: { required },
        dados: ['descricao']
    },

    methods: {
        async onLoadFile(file, fileList) {
            let url = process.env.VUE_APP_HTTP_PATH + '/laudo/upload-temp';
            let formData = new FormData();
            formData.append('file', file.raw);
            const { data, status } = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (status === 200) {
                const arq = { nomeArquivo: data, uid: file.uid };
                this.arquivosUploads.push(arq);
                this.emitDados();
            } else {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.naoFoiPossivelEnviarArquivo')
                });
            }
        },
        async onRemoveFile(file, fileList) {
            const arqRemover = this.arquivosUploads.filter(
                a => a.uid === file.uid
            );
            const { status } = await LaudosService.removerArquivoTemp(
                arqRemover[0].nomeArquivo
            );
            if (status === 200) {
                this.arquivosUploads = this.arquivosUploads.filter(
                    l => l.uid !== file.uid
                );
                this.emitDados();
                return true;
            } else {
                this.$notify.warning({
                    message: this.$t('mensagens.laudos.erro.naoFoiPossivelDeletarArquivo')
                });
                return false;
            }
        },
        verificarLimite() {
            this.$notify.warning({
                message: UploadHelp.MsgLimite(3)
            });
        },
        antesUploadArquivo(file) {
            if (file.size > UploadHelp.size) {
                return false;
            }
            return true;
        },
        async antesRemoverArquivo(file) {
            const result = await this.$messageBox.confirm(
                this.$t('mensagens.laudos.desejaRemoverEsteArquivo'),
                this.$t('mensagens.laudos.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            return result;
        },
        emitDados() {
            this.$emit('getValidacao', {
                valido: !this.$v.dados.$invalid,
                id: this.territorio.id
            });

            if (this.$v.dados.$invalid) {
                return;
            }

            let arquivosUploadNomes = [];
            if (this.arquivosUploads.length > 0) {
                Object.keys(this.arquivosUploads).forEach(item => {
                    arquivosUploadNomes.push(
                        this.arquivosUploads[item].nomeArquivo
                    );
                });
            }

            this.$emit('getDados', {
                dados: {
                    descricao: this.descricao,
                    territorioId: this.territorio.id,
                    nomeArquivos: arquivosUploadNomes,
                    tipoLaudoId: TipoLaudo.AVALIACAO_FUNDIARIA
                },
                id: this.territorio.id
            });
        }
    }
};
</script>

<style lang="scss" scoped>
#card-dados-territorio {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;
    width: 100% !important;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0 !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .form {
        .dados {
            display: flex;
            flex-direction: row;
            justify-content: start;
            gap: 26px;
            width: 100% !important;
        }

        .el-radio {
            min-width: 0px !important;
        }
    }
    .box {
        display: grid;
        grid-template-columns: auto 578px;
    }

    .upload-demo {
        padding: 10px;
    }

    @media (max-width: 1126px) {
        .box {
            display: flex;
            flex-wrap: wrap;
        }
    }
    .el-upload-dragger {
        height: 168px;
    }
    .arquivos.complementares {
        margin-left: 11px;
    }
}
.area-fixa {
    resize: none;
}
.tamanho-area-texto {
    min-width: -webkit-fill-available;
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}
.el-upload {
    flex: 1;
    .el-icon-upload {
        font-size: 40px;
        margin: 0px;
    }
}

.el-upload-dragger {
    width: 558px !important;
}
</style>
